import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';

import { environment } from '../../../environments/environment';

const loggerCallback = (
  level: LogLevel,
  message: string,
  containsPii: boolean
) => {
  //console.debug({ level, MSAL: message, containsPii });
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: '/',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true,
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', [
    'User.Read',
    'email',
    'profile',
    'openid',
  ]);
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/users', [
    'User.ReadBasic.All',
  ]);
  protectedResourceMap.set(environment.baseApiUrl, [
    'https://connected-beauty-dev.loreal.io/Configuration.Read',
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [
        'User.Read',
        'email',
        'profile',
        'openid',
        'https://connected-beauty-dev.loreal.io/Configuration.Read',
      ],
    },
    loginFailedRoute: '/authentication/login-failed',
  };
}
